<template>
<div class="box">
  <div class="arr">
<!--    <div v-for="(i,index) in list" class="tab">{{index+1}}-->
<!--    <div class="close" @click="close(i)">x</div>-->
<!--    </div>-->
  </div>
  <div class="text-box">
<!--    <iframe-->
<!--      v-for="(i,index) in list" :key="index"-->
<!--      class="iframe-box"-->
<!--      :src="i.url"-->
<!--      frameborder="0">-->
<!--    </iframe>-->
  </div>


</div>
</template>

<script>
export default {
  name: "test",
  data(){
    return{
      // list:[
      //   {url:'https://tdapp.novai.live/#/'},
      //   {url:'https://pancakeswap.finance/swap?chain=bsc&inputCurrency=0x1e8458EE8C9233c4669E78e460FA5B1e582f3792&outputCurrency=0x2CdB143d8432ec8ef86931005C9579F8416d3C77'},
      //   {url:'https://usai.novaichain.com/#/'},
      //   {url:'https://tdapp.novai.live/#/'},
      // ]
    }
  },
methods:{
  // close(i){
  //   const index = this.list.indexOf(i)
  //   if (index !== -1) {
  //     this.list.splice(index, 1)
  //   }
  // }
}
}
</script>

<style scoped>
.box{
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
}
.text-box{
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 50px;

}
.arr{
  display: flex;
  gap: 10px;
}
.tab{
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding: 10px 20px;
  background: green;
  color: #0A0D14;
  border-radius: 20%;
  cursor: pointer;
}
.iframe-box{
  width: 80%;
  height: 1000px;
}
</style>



// WEBPACK FOOTER //
// src/components/Lobby/test.vue